import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import VehicleForm from '../../../components/forms/VehicleForm/VehicleForm';
import './AddNewVehicle.css';

const AddNewVehicle = () => {
    const navigate = useNavigate();

    return (
        <Container fluid>
            <div className="add-vehicle-page mt-5 mb-4">
                <div className="d-flex align-items-center gap-3">
                    <Button
                        variant="outline-secondary"
                        onClick={() => navigate('/vehicle-management')}
                    >
                        Back
                    </Button>
                    <h3 className="mb-0">Add New Vehicle</h3>
                </div>
            </div>
            <VehicleForm isEditMode={false} />
        </Container>
    );
};

export default AddNewVehicle;
